import { useRef } from 'react';
var useLatest = function (value) {
    var ref = useRef(value);
    ref.current = value;
    return ref;
};
export default useLatest;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useLatest.js
// module id = 5obS
// module chunks = 0